import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function CircleProgress({ value, label, color = '#ff007a' }) {
    const wrapperRef = useRef(null)
    const progressRef = useRef(null)
    const percentRef = useRef(null)

    useEffect(() => {
        const r = 54
        const circumference = 2 * Math.PI * r
        if (!progressRef.current || !wrapperRef.current) return

        // Initialize ring as empty
        progressRef.current.style.strokeDasharray = `${circumference}`
        progressRef.current.style.strokeDashoffset = `${circumference}`

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: wrapperRef.current,
                start: 'top 75%',
                once: true
            }
        })

        // Stroke animate to target
        tl.to(progressRef.current, {
            strokeDashoffset: circumference * (1 - value / 100),
            duration: 1.4,
            ease: 'power2.out'
        }, 0)

        // Number animate 0 -> value
        const obj = { val: 0 }
        tl.to(obj, {
            val: value,
            duration: 1.4,
            ease: 'power2.out',
            onUpdate: () => {
                if (percentRef.current) percentRef.current.textContent = `${Math.round(obj.val)}%`
            }
        }, 0)

        return () => {
            tl.scrollTrigger && tl.scrollTrigger.kill()
            tl.kill()
        }
    }, [value])

    return (
        <div ref={wrapperRef} className='relative w-40 h-40 md:w-52 md:h-52'>
            <svg className='w-full h-full rotate-[-90deg]' viewBox='0 0 120 120' aria-label={`${label} progress`}>
                <circle cx='60' cy='60' r='54' stroke='currentColor' strokeWidth='8' className='text-pink-600/20 dark:text-pink-500/20 fill-none' />
                <circle ref={progressRef} cx='60' cy='60' r='54' stroke={color} strokeWidth='8' className='fill-none' />
            </svg>
            <div className='absolute inset-0 grid place-items-center rotate-0'>
                <div className='text-center'>
                    <div ref={percentRef} className='text-3xl md:text-4xl font-extrabold text-black dark:text-white'>0%</div>
                    <div className='text-xs md:text-sm mt-1 text-zinc-700 dark:text-zinc-300'>{label}</div>
                </div>
            </div>
        </div>
    )
}

const SubServiceDetailTestSec3 = () => {
    const skills = [
        { label: 'WordPress', value: 97 },
        { label: 'Custom Development', value: 96 },
        { label: 'Shopify', value: 91 },
        { label: 'WooCommerce', value: 94 },
    ]

    return (
        <div className='min-h-screen w-full bg-white dark:bg-zinc-900 dark:text-white xl:px-35 py-20'>
            <h1 className="text-4xl font-bold text-black dark:text-white text-center">Fast Turnaround <br />
                Beautiful & Functional Websites</h1>
            <div className='mt-16 flex items-center justify-center gap-8 md:gap-12 flex-wrap md:flex-nowrap'>
                {skills.map(s => (
                    <CircleProgress key={s.label} value={s.value} label={s.label} />
                ))}
            </div>
        </div>
    )
}

export default SubServiceDetailTestSec3